import { WorkOrderDto, ActivityDto } from '@app/generated/model';
import { failedToParseResponse } from 'node_modules/@azure/msal-browser/dist/error/BrowserAuthErrorCodes';

export class WorkOrder {
  constructor(workOrder: WorkOrderDto) {
    this.id = workOrder.id;
    this.workOrderNo = workOrder.workOrderNumber;
    this.title = workOrder.title;
    this.progress = workOrder.progress;
    this.estimatedStartDate = workOrder.startDate;
    this.estimatedFinishDate = workOrder.endDate;
    this.estimatedHours = workOrder.estimatedHours;
    this.actualHours = workOrder.actualHours / 60;
    this.actualMinutesUsed = workOrder.actualMinutesUsed;
    this.status = workOrder.status;
    this.isAssigned = workOrder.isAssigned;
    this.division = workOrder.division;
    this.closed = workOrder.closed;
    this.isFavourite = workOrder.isFavourite;
    this.statusName = workOrder.statusName;
    this.isReleased = workOrder.released;
    this.projectId = workOrder.projectId;
    this.weeksProgress = workOrder.weeksProgress;
    this.activity = workOrder.activity;
    this.taskNo = workOrder.activity?.functionalUnit;
    this.siteNo = workOrder.siteNo;
    this.isDownloading = false;
    this.pendingOfflineChanges = 0;
    this.showChangesSaved = false;
    this.commentCount = workOrder.commentCount ?? 0;
    this.weightLineSentCount = workOrder.weightLineSentCount ?? 0;
    this.weightLineTotalCount = workOrder.weightLineTotalCount ?? 0;
  }

  id: string;
  workOrderNo: string;
  title: string;
  progress: number;
  estimatedStartDate: string;
  estimatedFinishDate: string;
  estimatedHours: number;
  actualHours: number;
  actualMinutesUsed: number;
  status: 'UNRELEASED' | 'RELEASED' | 'ASSIGNED';
  isAssigned: boolean;
  division: 'SLS' | 'FABRICATION' | 'OFFSHORE';
  closed: boolean;
  downloaded?: boolean;
  isDownloading?: boolean;
  isFavourite: boolean;
  statusName: string;
  isReleased: boolean;
  projectId?: string;
  weeksProgress: number;
  activity?: ActivityDto;
  taskNo?: string;
  siteNo: string;
  lastSyncedAt?: Date | null;
  pendingOfflineChanges?: number;
  showChangesSaved?: boolean;
  commentCount: number;
  weightLineSentCount: number;
  weightLineTotalCount: number;
}
